import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import GroupIcon from '@mui/icons-material/Group'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'

interface Props {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuEmployees: FC<Props> = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}) => {
  const intl = useIntl()
  return (
    <MenuList disablePadding={true} onClick={toggleDrawerOnMobile}>
      <MenuItem
        key="employees"
        data-test="hr-bots_sidebar_menuitem"
        component={ButtonLink}
        href="/hr-bot/employees?page=1"
        selected={pathname.includes('hr-bot/employees')}
        className={nested}
      >
        <ListItemIcon data-test="hr-bot_sidemenu_icon">
          <GroupIcon />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({
            id: 'employees.sidebar',
          })}
        />
      </MenuItem>
    </MenuList>
  )
}
